export const currencyTypes = [
    { type: "INR", taxType: ["CGST", "SGST"] },
    { type: "INR_IGST", taxType: ["IGST"] },
    { type: "GBP", taxType: ["VAT"] },
    { type: "AED", taxType: ["VAT"] }
]
